<template>
  <div class="mvt-cardproperty-photo" @click.stop="onClick" :class="{'loading': isLoadingAnimation, 'hover-mode': isFocusMode }" :data-mls="property.formatMlsInfo || null">
    <mvtMapStatic v-if="showStreetView && property.photoCount === 0" type="streetview" streetViewDefautType="satellite"
      :lat="property.geo.lat" :lng="property.geo.lng" :address="property.geo.formatAddress"
      :title="property.geo.formatAddress" :alt="property.geo.formatAddress" :width="staticMapData.width"
      :height="staticMapData.height" :cacheFirst="true" />
    <div ref="photoContainer" class="mvt-cardproperty-photo-container" :class="animationName" v-else :data-alt="property.photoCount > 0 ? null : 'Photos coming soon'" @animationend="onAnimationEnd">
      <img loading="lazy" :src="photoUrl" :alt="property.photoCount > 0 ? property.geo.formatAddress : 'Photos coming soon'" />
      <img aria-hidden="true" v-if="nextPhotoUrl" :src="nextPhotoUrl" class="preload-prev">
      <img aria-hidden="true" v-if="prevPhotoUrl" :src="prevPhotoUrl" class="preload-next">
    </div>
    <button class="btn-3d" type="button"
      v-if="glb.pageType === 'vmapsearch' && property.isActive && property.threeDTourLink" data-link-name="3D">
      <img loading="lazy" :src="glb.cdnUrl + 'vimages/home_animate.svg'" alt="3D Tour" />
    </button>
    <button type="button" class="btn-prev" @click="prevPhoto" @mouseenter.once="initPhotoUrls" v-if="showPreview">
      <i class="icon-angle-left"></i>
    </button>
    <button type="button" class="btn-next" @click="nextPhoto" @mouseenter.once="initPhotoUrls" v-if="showPreview">
      <i class="icon-angle-right"></i>
    </button>
    <div class="mvt-cardproperty-loading" v-if="isLoadingAnimation"></div>
    <mvtCardPropertyPagination v-if="showPreview"
        :total="getPhotoCount"
        :currentIndex="index"
    />
    <span class="mvt-cardproperty-photo-count" v-if="showPreview">{{ index + 1 }} / {{ getPhotoCount }}</span>
  </div>
</template>

<script src="./mvt-cardproperty-image.js"></script>
